import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startSubmit } from 'redux-form';
import { closeModal } from '../../actions/close-modal';
import { getCurrentUserId } from '../../selectors/current-user-selectors';
import Modal from '../../components/modal';
import PostForm from '../../components/post-form';

export class PostCreateModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValues: { ownerId: props.ownerId, categoryId: props.categoryId },
    };
  }

  render() {
    const { closeModal: handleClose, categoryId, submit } = this.props;
    return (
      <Modal onClose={handleClose}>
        <PostForm
          onSubmit={handleClose}
          onSubmitButtonClick={submit}
          onCancel={() => handleClose()}
          initialValues={this.state.initialValues}
          categoryId={categoryId}
        />
      </Modal>
    );
  }
}

PostCreateModal.propTypes = {
  ownerId: PropTypes.string.isRequired,
  categoryId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  post: PropTypes.object,
};

const mapStateToProps = state => ({
  ownerId: getCurrentUserId(state),
});

const mapDispatchToProps = {
  closeModal,
  submit: () => startSubmit('post'),
};

export default connect(mapStateToProps, mapDispatchToProps)(PostCreateModal);



// WEBPACK FOOTER //
// ./app/containers/post-create-modal/post-create-modal.js